import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// A pasted Jira URL is a locator, not a label — cards show the issue key
// instead of the raw URL. Bare keys ("LTGDME-9929") pass through untouched.
// The key is matched anywhere in the URL (path or query) because Jira hands
// out board/backlog links carrying ?selectedIssue=KEY; a URL with no
// key-shaped token anywhere falls back to "Open".
const JIRA_URL_RE = /^https?:\/\//i;
const JIRA_KEY_RE = /[A-Za-z][A-Za-z0-9]*-\d+/;
export function jiraDisplay(value: string): string {
  if (!JIRA_URL_RE.test(value)) return value;
  try {
    const u = new URL(value);
    const m = decodeURIComponent(u.pathname + u.search).match(JIRA_KEY_RE);
    return m ? m[0] : "Open";
  } catch {
    return "Open";
  }
}

// The href side of the same URL-vs-key duality: a full URL links as-is,
// a bare key links to its browse page.
export function jiraHref(value: string): string {
  return JIRA_URL_RE.test(value) ? value : `https://lennar.atlassian.net/browse/${value}`;
}
